export enum JobServicePromiseEnum {
  AnyTime = 1,
  AM = 2,
  PM = 3,
  SpecificTime = 4
}
